import { apiClient } from "./apiClient"

export const installationApi = {
    fetchInstallationList: (businessEntityId, config, accessToken) => {
        return apiClient(`${config.managementServiceBaseUrl}/businessentities/${businessEntityId}/installations`, accessToken, {
            method: 'GET',
            headers: {
                'Clientid': 4,
                'Shift4-Rest-Request-Envelope-Version': '1',
                'Shift4-Rest-Response-Envelope-Version': '1'
            }
        })
    }
}